import semver from "./semver-lite.js";
const buildVersionedValue = (value, version) => {
  return JSON.stringify({
    value,
    version
  });
};
const buildStorageUtils = (storage_) => {
  return {
    setItem: (key, value, version) => {
      if (version) {
        value = buildVersionedValue(value, version);
      }
      storage_.setItem(key, value);
    },
    getItem: (key) => {
      const value = storage_.getItem(key);
      if (!value) {
        return null;
      }
      try {
        const jsonValue = JSON.parse(value);
        if ("version" in jsonValue) {
          return jsonValue.value;
        }
        return value;
      } catch (e) {
        return value;
      }
    },
    getVersion: (key) => {
      const value = storage_.getItem(key);
      if (!value) {
        return null;
      }
      try {
        const jsonValue = JSON.parse(value);
        if ("version" in jsonValue) {
          return jsonValue.version;
        }
        return null;
      } catch (e) {
        return null;
      }
    },
    invalidate: (key, version) => {
      const currentVersion = storage.local.getVersion(key);
      if (currentVersion) {
        if (!semver.eq(currentVersion, version)) {
          storage_.removeItem(key);
        }
      } else {
        return false;
      }
    }
  };
};
const storage = {
  local: buildStorageUtils(localStorage),
  session: buildStorageUtils(sessionStorage)
};
const storage$1 = storage;
export {
  storage$1 as default
};
